<template>
  <view 
    :class="{
      'page-container': true,
    }" 
    :data-current-url="$nowCurrentServer.value" 
    data-index="1"
  >
    <NuxtLayout>
      <PageRender v-if="!$isErpBuySite.value" :activeDetailData="activeDetailData" @contextmenu="onContextmenu"
        :edit="edit" :currentElementIndex="currentElementIndex" :currentElementIndexStr="currentElementIndexStr" />
      <ErpBuyIndexDefault v-if="$isErpBuySite.value" />
    </NuxtLayout>
  </view>
</template>

<script setup>
import { ref, computed, provide } from "vue";
import PageRender from "~/components/render/PageRender.vue";
import ErpBuyIndexDefault from "~/components/common/ErpBuyIndexDefault.vue";
import pageEditorUse, {
  getActiveDetailDataAsync
} from "~/composables/pageEditorUse";
import { useRoute, useNuxtApp } from "#app";
import { useMainStore } from "~/composables/store";

const { $isErpBuySite, $nowCurrentServer } = useNuxtApp()
const store = useMainStore();

const headers = useRequestHeaders();
const route = useRoute();
const currentPageIndex = ref(0);
const activeDetailKey = computed(() => `activeDetail:index:${route.fullPath}`);


let pageUrl = 'pc'
try {
  const matchedMallPageConfig = store.getMatchedMallPageConfig("index", $nowCurrentServer.value);
  if (matchedMallPageConfig?.pageUrl) {
    pageUrl = matchedMallPageConfig.pageUrl;
  }
} catch (e) {
  console.log(e);
}
const { data: activeDetailData } = await useAsyncData(
  activeDetailKey,
  getActiveDetailDataAsync.bind(this, { headers, $fetch, url: pageUrl }, { currentPageIndex }),
  {
    watch: [() => route.fullPath]
  }
);
let {
  onContextmenu,
  edit,
  currentElementIndex,
  currentElementIndexStr,
  getConfigJsonHook
} = pageEditorUse({
  activeDetailData,
  currentPageIndex
}, {
  isPage: true
});
// 提供函数给子组件使用
provide("getConfigJson", getConfigJsonHook);
</script>

<style scoped></style>
